<div class="app-update alert alert-danger" [hidden]="!nouvelleVersionDisponible">
	<div>
		<strong>{{ "SIGALE_ANGULAR.COMPONENTS.NOUVELLE_VERSION.LABEL_ATTENTION" | translate }}</strong> {{ "SIGALE_ANGULAR.COMPONENTS.NOUVELLE_VERSION.MESSAGE" | translate }} <a href="#" (click)="$event.preventDefault(); rafraichir()">{{ "NOUVELLE_VERSION.LABEL_OK" | translate }}</a>
	</div>
</div>
